import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { JwtService } from 'src/app/jwt.service';
import { ClienteManager } from 'src/app/managers/cliente-manager';
import { ItemManager } from 'src/app/managers/item-manager';
import { PedidoManager } from 'src/app/managers/pedido-manager';
import { SnackbarManager } from 'src/app/managers/snackbar-manager';
import { Cliente } from 'src/app/persistences/cliente';
import { ItemDetalhes } from 'src/app/persistences/item-detalhes';
import { PedidoVenda } from 'src/app/persistences/pedido-venda';
import { ConfigService } from 'src/app/services/config.service';
import { FormaCondService } from 'src/app/services/forma-cond.service';
import { CartSingletonService } from 'src/app/singletons/cart-singleton.service';
import { FormaCondPgto } from 'src/app/persistences/forma-cond-pgto';
import { ClienteSingletonService } from 'src/app/singletons/cliente-singleton.service';
import { ClienteService } from 'src/app/services/cliente.service';

@Component({
  standalone: false,
    selector: 'app-card-login',
    templateUrl: './card-login.component.html',
    styleUrls: ['./card-login.component.css'],
})
export class CardLoginComponent {
    public pedidoVenda: PedidoVenda;
    public itemDetalhes: ItemDetalhes;
    public btnLoginDesabilado = false;
    protected ngUnsubscribe: Subject<void> = new Subject<void>();
    public cpf_cnpj: string;

    constructor(
        private snackBarManager: SnackbarManager,
        private router: Router,
        private jwtService: JwtService,
        private cartSingleton: CartSingletonService,
        private config: ConfigService,
        private formcondService: FormaCondService,
        public itemManager: ItemManager,
        private pedidoManager: PedidoManager,        
        private clienteManager: ClienteManager,
        private clienteSingletonService: ClienteSingletonService,
        private clienteService: ClienteService,
    ) {
    }

    ngOnInit(): void {
        const token = localStorage.getItem('access_token_business');
        const loginEmAndamento = localStorage.getItem('login_em_andamento');
        const loginCompleto = localStorage.getItem('login_completo');
        if (token && loginEmAndamento === 'true' && loginCompleto !== 'true') {
            this.btnLoginDesabilado = true;
            this.inicializarPosLogin();
        }
    }

    async login(usuario: string, senha: string) {
        usuario = this.removerMascara(usuario);
        this.btnLoginDesabilado = true;
        if (usuario == '' || senha == '') {
            this.btnLoginDesabilado = false;
            this.snackBarManager.openSnackBar('Usuario ou senha inválido.', 'Fechar', 2000);
            return;
        }
        localStorage.setItem('login_em_andamento', 'true');
        localStorage.removeItem('login_completo');
        this.jwtService.login(usuario, senha).subscribe((res) => {            
            if (res['status'] == false) {
                this.btnLoginDesabilado = false;
                this.snackBarManager.openSnackBar(res['mensagem'], 'Fechar', 2000);
                localStorage.removeItem('login_em_andamento');
            } else {
                this.config.configuraLayout(this.config.getConfig().getLayout === 2 ? true : false);                
                localStorage.setItem('access_token_business', res['access_token']);
                localStorage.setItem('expires_at_business', res['expires_at']);
                localStorage.setItem('cd_usuario_business', res['cd_usuario']);                
                localStorage.setItem('filial_business', res['filial']);
                localStorage.setItem('usuario', usuario);
                this.clienteSingletonService.atualizarCdCliente(res['cd_cliente']);      
                if (this.clienteSingletonService.getClienteEstatico().getCdCliente == 0) {         
                    this.clienteManager.getFilialServidor(Number.parseInt(localStorage.getItem('filial_business')));
                }
                localStorage.setItem('expires_at_seconds_business', res['expires_at_seconds']); 
                this.inicializarPosLogin();   
            }
        }, (error: HttpErrorResponse) => {
            this.btnLoginDesabilado = false;
            if(error.status == 0){
                this.snackBarManager.openSnackBar(("Não foi possível estabeler conexão com o servidor" ), 'Ok', 2000);
            }
        });
    }

    private async inicializarPosLogin(): Promise<void>{
        this.config.loadFullConfig();           
        this.jwtService.temAcesso().subscribe((r: boolean) => {
            localStorage.setItem('tem_acesso_business', r ? '1' : '0');
        },
        (error: HttpErrorResponse) => {
            this.btnLoginDesabilado = false;
            this.snackBarManager.openSnackBar(error.error, 'Fechar', 2000);
        })        
        const cliente: Cliente = this.clienteSingletonService.getClienteEstatico();
        if (cliente.getCdCliente != 0) {
            this.clienteService.clienteTemVendedorPadrao().subscribe((resposta) => {
                if (resposta['status'] == false) {
                    this.btnLoginDesabilado = false;
                    localStorage.removeItem('login_em_andamento');
                    this.snackBarManager.openSnackBar(resposta['mensagem'] ,"Ok", 3000);
                    return
                }else{
                    this.clienteManager.getClientefromServico().then(() => {
                        this.formcondService.getFormaCondPgto(cliente.getCdCliente).subscribe(
                            (response) => {
                                if(response.formas.length == 0){
                                    this.btnLoginDesabilado = false;
                                    this.jwtService.logout();
                                    this.snackBarManager.openSnackBar("O usuário não possui perfil comercial com forma e condição de pagamento","Ok", 3000);
                                    localStorage.removeItem('login_em_andamento');
                                    return
                                }

                                const formasAgrupadas: FormaCondPgto[] = [];
                                response.formas.forEach( forma => {
                                    const cdForma = forma.cdFormaPgto;
                                    if(!formasAgrupadas.some(item => item.cdFormaPgto === cdForma)){
                                        formasAgrupadas.push(forma)
                                    } else{
                                        forma.condicoes.forEach(cond => {
                                            const formaAtual = formasAgrupadas.find(forma => forma.cdFormaPgto === cdForma)
                                            if(!formaAtual.condicoes.some(item => item.cdCondPgto === cond.cdCondPgto)){
                                                formasAgrupadas.forEach(forma => {
                                                    if(forma.cdFormaPgto === cdForma){
                                                        forma.condicoes.push(cond);
                                                    }
                                                })
                                            }
                                        })
                                    }
                                })
                                this.cartSingleton.setFormaECondicaoDePagamento(formasAgrupadas);
                                this.clienteSingletonService.atualizaFormaCodPadrao(formasAgrupadas);
                                this.pedidoManager
                                .promiseBuscarPedidoEdicao()
                                    .then(() => {
                                        this.pedidoVenda = this.cartSingleton.getPedidoVenda();
                                        if (this.pedidoVenda.getIdGeral != undefined) {
                                            let obs = '';

                                            if(this.pedidoVenda.getObservacoesInterna != undefined && this.pedidoVenda.getObservacoesInterna.trim() != ''){
                                                obs = this.pedidoVenda.getObservacoesInterna
                                            } 
                                            this.cartSingleton.atualizarDadosCabecalho(this.pedidoVenda.getCdFormaPgto, this.pedidoVenda.getCdCondPgto, this.pedidoVenda.getCdTpEntrega, obs);
                                            this.pedidoManager.carregarInformacaoPedidoEdicao();
                                        } else {                                            
                                            this.pedidoManager.promiseNovoPedidoVenda().then(
                                                () => {
                                                    localStorage.removeItem('login_em_andamento');
                                                    localStorage.setItem('login_completo', 'true');
                                                    this.router.navigateByUrl('/home')
                                                })
                                                .catch((error) => {
                                                    localStorage.removeItem('login_em_andamento');
                                                    this.btnLoginDesabilado = false;
                                                    this.snackBarManager.openSnackBar(error.error, 'Ok', 3000);
                                                });
                                        }                                 
                                })
                                .catch((error) => {
                                    this.btnLoginDesabilado = false;
                                    localStorage.removeItem('login_em_andamento');
                                    this.snackBarManager.openSnackBar(error.error, 'Ok', 3000);
                                });
                            },
                            (error: HttpErrorResponse) => {
                                this.btnLoginDesabilado = false;
                                localStorage.removeItem('login_em_andamento');
                                this.snackBarManager.openSnackBar(error.error, 'Fechar', 2000);
                            }
                        );
                    });
                }  
            },
            (error: HttpErrorResponse) => {
                this.btnLoginDesabilado = false;      
                localStorage.removeItem('login_em_andamento');           
                this.snackBarManager.openSnackBar(error.error, 'Fechar', 3000);
                return                
            });
        }else {
            localStorage.removeItem('login_em_andamento');
            localStorage.setItem('login_completo', 'true');
            this.router.navigateByUrl('/home');
        }
    }

    getCpfCnpjMask() {
        if (this.cpf_cnpj == undefined) return;

        const raw = this.removerMascara(this.cpf_cnpj);
        this.cpf_cnpj = raw;

        // Só formata se for puramente numérico (CPF ou CNPJ)
        if (!/^\d*$/.test(raw)) return;

        if (raw.length > 11) {
            // CNPJ: ##.###.###/####-##
            if (raw.length <= 2)  return this.cpf_cnpj = raw;
            if (raw.length <= 5)  return this.cpf_cnpj = raw.replace(/^(\d{2})(\d{1,3})/, "$1.$2");
            if (raw.length <= 8)  return this.cpf_cnpj = raw.replace(/^(\d{2})(\d{3})(\d{1,3})/, "$1.$2.$3");
            if (raw.length <= 12) return this.cpf_cnpj = raw.replace(/^(\d{2})(\d{3})(\d{3})(\d{1,4})/, "$1.$2.$3/$4");
            return this.cpf_cnpj = raw.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{1,2})/, "$1.$2.$3/$4-$5");
        }

        // CPF: ###.###.###-##
        if (raw.length == 3)       return this.cpf_cnpj = raw.replace(/^(\d{3})/, "$1.");
        else if (raw.length == 4)  return this.cpf_cnpj = raw.replace(/^(\d{3})(\d{1})/, "$1.$2");
        else if (raw.length == 5)  return this.cpf_cnpj = raw.replace(/^(\d{3})(\d{2})/, "$1.$2");
        else if (raw.length == 6)  return this.cpf_cnpj = raw.replace(/^(\d{3})(\d{3})/, "$1.$2.");
        else if (raw.length == 7)  return this.cpf_cnpj = raw.replace(/^(\d{3})(\d{3})(\d{1})/, "$1.$2.$3");
        else if (raw.length == 8)  return this.cpf_cnpj = raw.replace(/^(\d{3})(\d{3})(\d{2})/, "$1.$2.$3");
        else if (raw.length == 9)  return this.cpf_cnpj = raw.replace(/^(\d{3})(\d{3})(\d{3})/, "$1.$2.$3-");
        else if (raw.length == 10) return this.cpf_cnpj = raw.replace(/^(\d{3})(\d{3})(\d{3})(\d{1})/, "$1.$2.$3-$4");
        else if (raw.length == 11) return this.cpf_cnpj = raw.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    }

    removerMascara(string: string) {
        return string = string.split('.').join('').split('-').join('').split('/').join('');
    }
}
